<app-conditional-layout>
  <router-outlet />
</app-conditional-layout>
<app-toast-notification />
